import { Observable } from 'rxjs';
import { ItemDetailResponse } from './../model/itemdetailinfo';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../common/constants/common-constants';

@Injectable()
export class ItemDetailService {

    constructor(public http: HttpClient) {
    }

    // function call to fetch item detail
        public getItemDetail(itemId: number): Observable<ItemDetailResponse> {
            return this.http.get<ItemDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
                + '/customer/ci/items/' + itemId);
        }

        public getOutageItemDetail(itemId: number): Observable<ItemDetailResponse> {
            return this.http.get<ItemDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
                + '/customer/outages/' + itemId);
        }

}
